import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiService } from './api.service';
import { ILoginResp } from 'src/app/state/models/LoginResponse';
import { IResponseObject } from 'src/app/state/models/common.model';
import {
  IApiResponse,
  IAuthForgotPassword,
  IAuthChangePassword,
} from 'src/app/state/models/auth.model';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly apiUrl = `${environment.apiBaseUrl}/api/auth`;

  constructor(private readonly apiService: ApiService) {}

  login(
    username: string,
    password: string,
    captchaInput?: string
  ): Promise<any> {
    return this.apiService.post(`${this.apiUrl}/login`, {
      username,
      password,
      captchaInput,
    });
  }

  forgotPassword(username: string): Promise<IApiResponse<IAuthForgotPassword>> {
    return this.apiService.post(`${this.apiUrl}/forgotpassword`, { username });
  }

  isSessionExist(): Promise<any> {
    return this.apiService.get(`${this.apiUrl}/isSessionExist`);
  }

  logout(): Promise<any> {
    return this.apiService.get(`${this.apiUrl}/logout`);
  }

  generateCaptcha(): Promise<any> {
    return this.apiService.get(`${this.apiUrl}/generate-captcha`);
  }

  useMagicLink(email: string): Promise<any> {
    return this.apiService.post(`${this.apiUrl}/login-magiclink`, { email });
  }

  validateMagicLink(token: string): Promise<IResponseObject<ILoginResp>> {
    return this.apiService.post(`${this.apiUrl}/validate-magiclink`, { token });
  }

  validateResetToken(token: string, isResetToken:boolean = true): Promise<IResponseObject<ILoginResp>> {
    return this.apiService.post(
      `${this.apiUrl}/validate-reset-token/${token}?isResetToken=${isResetToken}`,
      {}
    );
  }

  validateMagicOTP(email: string, otp: string): Promise<IResponseObject<any>> {
    return this.apiService.post(`${this.apiUrl}/login-otp`, { email, otp });
  }

  validateMFAOTP(email: string, otp: string): Promise<IResponseObject<any>> {
    return this.apiService.post(`${this.apiUrl}/otp-verify`, { email, otp });
  }

  resetPassword(
    token: string,
    newPassword: string,
    confirmPassword: string
  ): Promise<IApiResponse<IAuthForgotPassword>> {
    return this.apiService.post(`${this.apiUrl}/resetPassword`, {
      token,
      newPassword,
      confirmPassword,
    });
  }
  changePassword(
    oldPassword: string,
    newPassword: string
  ): Promise<IApiResponse<IAuthChangePassword>> {
    return this.apiService.post(`${this.apiUrl}/changepassword`, {
      oldPassword,
      newPassword,
    });
  }
  resendMFAOTP(email: string): Promise<IApiResponse<{}>> {
    return this.apiService.post(`${this.apiUrl}/resend-mfa-otp`, {
      email,
    });
  }
}
